import StringSchema from "yup/lib/string";

import { requiredMessage, maxLengthMessage } from "../validationMessages";

import { trimmedString } from "./trimmedString";

export const textareaValidator = (length: number): StringSchema =>
  trimmedString.max(length, maxLengthMessage(length));
export const textareaValidatorRequired = (length: number): StringSchema =>
  trimmedString.max(length, maxLengthMessage(length)).required(requiredMessage);
